import styled from 'styled-components';
import { Button, colors } from '@insurancemenu/imenu-components-lib';

export const DefaultContactSectionStyled = styled.div`
  margin-bottom: 7rem;
`;

export const AdditionalContactsSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AdditionalContactsStyled = styled.div`
  display: flex;
  gap: 2rem;
  margin-bottom: 3rem;
`;

export const ContactFieldsListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const DefaultContactTitleStyled = styled.h3`
  font-size: 2.4rem;
  color: ${colors.neutral[900]};
  margin: 0 0 3rem;
  padding-bottom: 1.6rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
`;

export const AdditionalContactTitleStyled = styled.h3`
  font-size: 2.4rem;
  color: ${colors.neutral[900]};
  margin: 0;
`;

export const AdditionalContactHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.6rem;
  margin-bottom: 4rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
`;

export const ContactFieldWrapperStyled = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 4rem;
  margin: 0;
`;

export const ListTitleStyled = styled.p`
  font-size: 1.6rem;
  font-weight: 600;
  color: ${colors.neutral[900]};
  margin: 0;
  padding-bottom: 2rem;
`;

export const ButtonStyled = styled(Button)`
  padding-top: 1%;
  font-weight: 700;
  text-transform: uppercase;
  min-width: 15rem;
`;
export const AddContactButtonStyled = styled(Button)`
  min-width: 15rem;
`;

export const NoItemsMessageStyled = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${colors.neutral[900]};
  margin: 0;
`;
